import React, { Component } from "react";

class Answer extends Component {
  state = {};
  render() {
    return (
      <div className="answer_only">
        <label>{this.props.answer.name}</label>
        <label className="title">{this.props.answer.user.username}</label>
      </div>
    );
  }
}

export default Answer;



// WEBPACK FOOTER //
// ./src/components/answers/answer.jsx